<template>
  <div class="card">
    <div class="toolbar">
      <input v-model.trim="query.name" placeholder="商家名称" />
      <select v-model="query.status">
        <option value="">全部状态</option>
        <option value="active">启用</option>
        <option value="inactive">停用</option>
      </select>
      <button @click="fetchData">查询</button>
      <button class="primary" @click="resetForm">新增商家</button>
    </div>

    <div v-if="editing" class="editor">
      <h4>{{ form.id ? '编辑商家' : '新增商家' }}</h4>
      <div class="grid">
        <input v-model.trim="form.name" placeholder="商家名称*" />
        <input v-model.trim="form.channel_type" placeholder="渠道类型" />
        <input v-model.trim="form.contact_name" placeholder="联系人" />
        <input v-model.trim="form.contact_phone" placeholder="联系方式" />
        <select v-model="form.status">
          <option value="active">启用</option>
          <option value="inactive">停用</option>
        </select>
        <input v-model.trim="form.remark" placeholder="备注" />
      </div>
      <div class="actions">
        <button class="primary" @click="save">保存</button>
        <button @click="editing = false">取消</button>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>名称</th>
          <th>渠道</th>
          <th>联系人</th>
          <th>电话</th>
          <th>状态</th>
          <th>更新时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in list" :key="row.id">
          <td>{{ row.id }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.channel_type }}</td>
          <td>{{ row.contact_name }}</td>
          <td>{{ row.contact_phone }}</td>
          <td>{{ row.status === 'active' ? '启用' : '停用' }}</td>
          <td>{{ row.updated_at }}</td>
          <td>
            <button @click="editRow(row)">编辑</button>
            <button @click="toggleStatus(row)">{{ row.status === 'active' ? '停用' : '启用' }}</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { merchantList, merchantSave, merchantStatus } from '@/api/priceMonitor'

export default {
  name: 'MerchantManager',
  data() {
    return {
      query: { name: '', status: '', page: 1, pageSize: 20 },
      list: [],
      editing: false,
      form: this.getEmptyForm()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    getEmptyForm() {
      return {
        id: 0,
        name: '',
        channel_type: '',
        contact_name: '',
        contact_phone: '',
        remark: '',
        status: 'active'
      }
    },
    async fetchData() {
      const res = await merchantList(this.query)
      if (res.code === 200) {
        this.list = res.data.list || []
      } else {
        alert(res.msg || '查询失败')
      }
    },
    resetForm() {
      this.form = this.getEmptyForm()
      this.editing = true
    },
    editRow(row) {
      this.form = { ...row }
      this.editing = true
    },
    async save() {
      if (!this.form.name) {
        alert('商家名称必填')
        return
      }
      const res = await merchantSave(this.form)
      if (res.code === 200) {
        this.editing = false
        this.fetchData()
      } else {
        alert(res.msg || '保存失败')
      }
    },
    async toggleStatus(row) {
      const res = await merchantStatus({
        id: row.id,
        status: row.status === 'active' ? 'inactive' : 'active'
      })
      if (res.code === 200) {
        this.fetchData()
      } else {
        alert(res.msg || '状态更新失败')
      }
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; padding: 16px; }
.toolbar { display: flex; gap: 10px; margin-bottom: 12px; }
.editor { background: #f9fafb; border: 1px solid #e5e7eb; padding: 12px; border-radius: 8px; margin-bottom: 12px; }
.grid { display: grid; grid-template-columns: repeat(3, minmax(180px, 1fr)); gap: 10px; }
.actions { margin-top: 10px; display: flex; gap: 8px; }
input, select, button { height: 34px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 6px; background: #fff; }
button { cursor: pointer; }
button.primary { background: #2563eb; color: #fff; border-color: #2563eb; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 13px; text-align: left; }
</style>
